import { defineComponent } from 'vue';
import { storeJobSeekers } from '@/api/backend/career';
import route from '@router/route';

export default defineComponent({
    name: 'JobSeekerMixin',
    methods: {
        storeJobSeekerStatus(target = '_blank', routeName = '', query = '') {
            if (target === '_self') {
                // eslint-disable-next-line no-return-assign
                return storeJobSeekers().then(() => (window.location.href = route(routeName, query)));
            }
            return storeJobSeekers();
        },
    },
});
